/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCloud = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M3.102 18h14.507C19.479 18 21 16.296 21 14.201c0-1.565-.877-2.99-2.181-3.55l-.614-.262-.02-.72C18.125 7.613 16.637 6 14.796 6c-1.531 0-2.878 1.155-3.275 2.81l-.268 1.114-1.005-.352a2.68 2.68 0 0 0-.884-.15c-1.629 0-2.954 1.486-2.954 3.311 0 .134.006.267.021.396l.086.8-.674.325C4.421 14.942 3.414 16.35 3.102 18m14.507 2H1v-1.067c0-2.646 1.319-5.061 3.411-6.343.063-2.904 2.26-5.244 4.953-5.244.183 0 .364.01.544.032C10.78 5.348 12.676 4 14.796 4c2.718 0 4.951 2.14 5.333 4.982C21.869 9.986 23 11.984 23 14.152 23 17.378 20.582 20 17.609 20"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCloud as Cloud };
